// extracted by mini-css-extract-plugin
export var countdownWrapper = "CountdownSection-module--countdownWrapper--4bdc6";
export var titleSection = "CountdownSection-module--titleSection--07a1d";
export var wrapper = "CountdownSection-module--wrapper--d439f";